import(/* webpackMode: "eager" */ "/home/ubuntu/apps/dotadmin/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/apps/dotadmin/src/AntdRegistry.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/apps/dotadmin/src/app/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/apps/dotadmin/src/app/loading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/apps/dotadmin/src/ProtectedRoutes/ProtectedLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/apps/dotadmin/src/Utils/AppInitializer.ts");
